// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header-module--wrapper--p3yFB","title":"header-module--title--bRpng","subtitle":"header-module--subtitle--I41HC"};